module.exports = __webpack_public_path__ + "img/adult.3293d2a7.jpg";